import { ROLE_PRIVILEGE } from '../enums/roles';

export const hasRole = (roles, r) => roles.map(it => ROLE_PRIVILEGE[it]).filter(it => it <= ROLE_PRIVILEGE[r]).length !== 0